import { message, subscriptionURL } from 'src/constantsMessage';
import axios from 'src/utils/axiosHelper';
import { SET_ALERT } from './alertAction';
import { registerEmpty } from './registerActions';
import authService from 'src/services/authService';
import helperAxios from 'src/utils/helperAxios';
import getProductType from 'src/components/ProductType';

const productType = getProductType();

export const GET_CLIENT_DETAILS = '@subscription/GET_CLIENT_DETAILS';
export const GET_CLIENT_DETAILS_ERROR =
  '@subscription/GET_CLIENT_DETAILS-error';
export const GET_CLIENT_DETAILS_EMPTY =
  '@subscription/GET_CLIENT_DETAILS-EMPTY';
export const REMOVE_CLIENT_DETAILS = '@subscription/REMOVE_CLIENT_DETAILS';
export const REMOVE_CLIENT_DETAILS_ERROR =
  '@subscription/REMOVE_CLIENT_DETAILS-error';
export const REMOVE_CLIENT_DETAILS_EMPTY =
  '@subscription/REMOVE_CLIENT_DETAILS-EMPTY';
export const VERIFY_PAYMENT = '@subscription/VERIFY_PAYMENT';
export const VERIFY_PAYMENT_ERROR = '@subscription/VERIFY_PAYMENT-error';
export const VERIFY_PAYMENT_EMPTY = '@subscription/VERIFY_PAYMENT-eMPTY';
export const SUBSCRIPTION_DETAILS = '@subscription/SUBSCRIPTION_DETAILS';
export const SUBSCRIPTION_DETAILS_ERROR =
  '@subscription/SUBSCRIPTION_DETAILS-error';
export const SUBSCRIPTION_DETAILS_EMPTY =
  '@subscription/SUBSCRIPTION_DETAILS-eMPTY';
export const CANCEL_SUBSCRIPTION_DETAILS =
  '@subscription/CANCEL_SUBSCRIPTION_DETAILS';
export const CANCEL_SUBSCRIPTION_DETAILS_ERROR =
  '@subscription/CANCEL_SUBSCRIPTION_DETAILS-error';
export const CANCEL_SUBSCRIPTION_DETAILS_EMPTY =
  '@subscription/CANCEL_SUBSCRIPTION_DETAILS-eMPTY';
export const CHANGE_PLAN_SUCCESS = '@subscription/CHANGE_PLAN_SUCCESS';
export const CHANGE_PLAN_ERROR = '@subscription/CHANGE_PLAN-error';
export const CHANGE_PLAN_EMPTY = '@subscription/CHANGE_PLAN-eMPTY';
export const CHANGE_PRIMARYCONTACT_SUCCESS =
  '@subscription/CHANGE_PRIMARYCONTACT_SUCCESS';
export const CHANGE_PRIMARYCONTACT_ERROR =
  '@subscription/CHANGE_PRIMARYCONTACT-error';
export const CHANGE_PRIMARYCONTACT_EMPTY =
  '@subscription/CHANGE_PRIMARYCONTACT-eMPTY';
export const CANCEL_SUBSCRIPTION_SUCCESS =
  '@subscription/CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_ERROR =
  '@subscription/CANCEL_SUBSCRIPTION-error';
export const CANCEL_SUBSCRIPTION_EMPTY =
  '@subscription/CANCEL_SUBSCRIPTION-eMPTY';
export const VERIFY_CANCEL_SUBSCRIPTION_SUCCESS =
  '@subscription/VERIFY_CANCEL_SUBSCRIPTION_SUCCESS';
export const VERIFY_CANCEL_SUBSCRIPTION_ERROR =
  '@subscription/VERIFY_CANCEL_SUBSCRIPTION-error';
export const VERIFY_CANCEL_SUBSCRIPTION_EMPTY =
  '@subscription/VERIFY_CANCEL_SUBSCRIPTION-eMPTY';
export const CHANGE_PAYMENT_METHOD_SUCCESS =
  '@subscription/CHANGE_PAYMENT_METHOD_SUCCESS';
export const CHANGE_PAYMENT_METHOD_ERROR =
  '@subscription/CHANGE_PAYMENT_METHOD-error';
export const CHANGE_PAYMENT_METHOD_EMPTY =
  '@subscription/CHANGE_PAYMENT_METHOD-eMPTY';
export const RENEW_SUBSCRIPTION_SUCCESS =
  '@subscription/RENEW_SUBSCRIPTION_SUCCESS';
export const RENEW_SUBSCRIPTION_ERROR =
  '@subscription/RENEW_SUBSCRIPTION-error';
export const RENEW_SUBSCRIPTION_EMPTY =
  '@subscription/RENEW_SUBSCRIPTION-eMPTY';
export const REVERT_SUBSCRIPTION_SUCCESS =
  '@subscription/REVERT_SUBSCRIPTION_SUCCESS';
export const REVERT_SUBSCRIPTION_ERROR =
  '@subscription/REVERT_SUBSCRIPTION-error';
export const REVERT_SUBSCRIPTION_EMPTY =
  '@subscription/REVERT_SUBSCRIPTION-eMPTY';
export const VERIFY_RENEW_SUBSCRIPTION_SUCCESS =
  '@subscription/VERIFY_RENEW_SUBSCRIPTION_SUCCESS';
export const VERIFY_RENEW_SUBSCRIPTION_ERROR =
  '@subscription/VERIFY_RENEW_SUBSCRIPTION-error';
export const VERIFY_RENEW_SUBSCRIPTION_EMPTY =
  '@subscription/VERIFY_RENEW_SUBSCRIPTION-eMPTY';
export const LOADER = '@subscription/subscriptionloader';
export const LOGIN_FAILURE = '@account/login-failure';
export const REVERT_ONLY_SUCCESS = '@subscription/REVERT_ONLY_SUCCESS';
export const REVERT_ONLY_ERROR = '@subscription/REVERT_ONLY-error';
export const REVERT_ONLY_EMPTY = '@subscription/REVERT_ONLY-eMPTY';

export const getClientDetails = clientId => {
  const url = `${subscriptionURL}/clientDetails?clientId=${clientId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: GET_CLIENT_DETAILS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CLIENT_DETAILS_ERROR,
          payload: error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
};

export const getClientDetailsEmpty = () => {
  return dispatch => {
    dispatch({ type: GET_CLIENT_DETAILS_EMPTY });
  };
};

export function removeClientDetails(clientId, type) {
  const url = `${subscriptionURL}/removeClientDetails?clientId=${clientId}&type=${
    type ? type : ''
  }`;
  const request = helperAxios(url, 'delete');
  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: REMOVE_CLIENT_DETAILS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: REMOVE_CLIENT_DETAILS_ERROR,
          payload: error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export const removeClientDetailsEmpty = () => {
  return dispatch => {
    dispatch({ type: REMOVE_CLIENT_DETAILS_EMPTY });
  };
};

export function verifyPayment(razorpayResponse, clientId, isRenew, type) {
  const url = `${subscriptionURL}/verifyPayment?clientId=${clientId}&type=${
    type ? type : ''
  }`;
  const bodyData = {
    paymentId: razorpayResponse.razorpay_payment_id,
    signature: razorpayResponse.razorpay_signature
  };
  isRenew && (bodyData.isExistingUser = true);

  const request = helperAxios(url, 'post', bodyData);

  return async dispatch => {
    dispatch({ type: LOADER });
    request
      .then(async response => {
        if (response.data && response.data.token) {
          authService.setSession(response.data.token);
          try {
            const user = await authService.loginInWithToken();
            dispatch({
              type: '@account/login-success',
              payload: {
                user
              }
            });
          } catch (error) {
            dispatch({ type: LOGIN_FAILURE });
            // throw error;
          }
        }
        dispatch({
          type: VERIFY_PAYMENT,
          payload: response.data
        });
      })

      .catch(error => {
        dispatch({
          type: VERIFY_PAYMENT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
        dispatch(registerEmpty());
      });
  };
}

export function verifyPaymentEmpty() {
  return dispatch => {
    dispatch({ type: VERIFY_PAYMENT_EMPTY });
  };
}

export function getSubscriptionDetails(clientId) {
  const url = `${subscriptionURL}/details?clientId=${clientId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: SUBSCRIPTION_DETAILS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: SUBSCRIPTION_DETAILS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: `/${productType.toLowerCase()}/home`
        });
      });
  };
}

export const getSubscriptionDetailsEmpty = () => {
  return dispatch => {
    dispatch({ type: SUBSCRIPTION_DETAILS_EMPTY });
  };
};

export function getCancelSubscriptionDetails(clientId) {
  const url = `${subscriptionURL}/cancelDetails?clientId=${clientId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: CANCEL_SUBSCRIPTION_DETAILS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: CANCEL_SUBSCRIPTION_DETAILS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: `/${productType.toLowerCase()}/home`
        });
      });
  };
}

export const getCancelSubscriptionDetailsEmpty = () => {
  return dispatch => {
    dispatch({ type: CANCEL_SUBSCRIPTION_DETAILS_EMPTY });
  };
};

export function changePlan(planId, clientId) {
  const bodyData = { clientId: clientId, planId: planId };
  const url = `${subscriptionURL}/updatePlan`;
  const request = helperAxios(url, 'post', bodyData);

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: CHANGE_PLAN_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: CHANGE_PLAN_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function changePlanEmpty() {
  return dispatch => {
    dispatch({ type: CHANGE_PLAN_EMPTY });
  };
}

export function changePrimaryContact(clientId, userId) {
  const bodyData = { clientId: clientId, userId: userId };
  const url = `${subscriptionURL}/changePrimaryContact`;
  const request = helperAxios(url, 'post', bodyData);

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: CHANGE_PRIMARYCONTACT_SUCCESS,
          payload: response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: message.primaryContactChanged,
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: CHANGE_PRIMARYCONTACT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function changePrimaryContactEmpty() {
  return dispatch => {
    dispatch({ type: CHANGE_PRIMARYCONTACT_EMPTY });
  };
}

export function cancelSubscription(clientId) {
  const url = `${subscriptionURL}/cancel?clientId=${clientId}`;
  const request = helperAxios(url, 'post');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: CANCEL_SUBSCRIPTION_SUCCESS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: CANCEL_SUBSCRIPTION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function cancelSubscriptionEmpty() {
  return dispatch => {
    dispatch({ type: CANCEL_SUBSCRIPTION_EMPTY });
  };
}

export function verifyCancelSubscription(razorpayResponse, clientId) {
  const bodyData = {
    paymentId: razorpayResponse.razorpay_payment_id,
    signature: razorpayResponse.razorpay_signature
  };
  const url = `${subscriptionURL}/verifyCancelSubscription?clientId=${clientId}`;
  const request = helperAxios(url, 'post', bodyData);

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: VERIFY_CANCEL_SUBSCRIPTION_SUCCESS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: VERIFY_CANCEL_SUBSCRIPTION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function verifyCancelSubscriptionEmpty() {
  return dispatch => {
    dispatch({ type: VERIFY_CANCEL_SUBSCRIPTION_EMPTY });
  };
}

export function renewSubscription(clientId) {
  const url = `${subscriptionURL}/renewSubscription?clientId=${clientId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: RENEW_SUBSCRIPTION_SUCCESS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: RENEW_SUBSCRIPTION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function renewSubscriptionEmpty() {
  return dispatch => {
    dispatch({ type: RENEW_SUBSCRIPTION_EMPTY });
  };
}

export function revertSubscription(clientId) {
  const url = `${subscriptionURL}/revertRenewal?clientId=${clientId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: REVERT_SUBSCRIPTION_SUCCESS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: REVERT_SUBSCRIPTION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function revertSubscriptionEmpty() {
  return dispatch => {
    dispatch({ type: REVERT_SUBSCRIPTION_EMPTY });
  };
}

export function verifyRenewSubscription(razorpayResponse, clientId) {
  const bodyData = {
    paymentId: razorpayResponse.razorpay_payment_id,
    signature: razorpayResponse.razorpay_signature,
    isExistingUser: true
  };
  const url = `${subscriptionURL}/verifyPayment?clientId=${clientId}`;
  const request = helperAxios(url, 'post', bodyData);

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: VERIFY_RENEW_SUBSCRIPTION_SUCCESS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: VERIFY_RENEW_SUBSCRIPTION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function verifyRenewSubscriptionEmpty() {
  return dispatch => {
    dispatch({ type: VERIFY_RENEW_SUBSCRIPTION_EMPTY });
  };
}

export const changePaymentMethod = (razorpayResponse, subscriptionId) => {
  const bodyData = {
    paymentId: razorpayResponse.razorpay_payment_id,
    subscriptionId: subscriptionId
  };
  const url = `${subscriptionURL}/changeCard`;
  const request = helperAxios(url, 'post', bodyData);

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: CHANGE_PAYMENT_METHOD_SUCCESS,
          payload: response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: message.methodSuccess,
          payload1: 'success',
          redirect: `/${productType.toLowerCase()}/subscription`,
          asOk: true
        });
      })
      .catch(error => {
        dispatch({
          type: CHANGE_PAYMENT_METHOD_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
};

export function changePaymentMethodEmpty() {
  return dispatch => {
    dispatch({ type: CHANGE_PAYMENT_METHOD_EMPTY });
  };
}

export function revertOnly(clientId) {
  const url = `${subscriptionURL}/revert?clientId=${clientId}`;
  const request = helperAxios(url, 'post');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: REVERT_ONLY_SUCCESS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: REVERT_ONLY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function revertOnlyEmpty() {
  return dispatch => {
    dispatch({ type: REVERT_ONLY_EMPTY });
  };
}
